import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/apiClient";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate(location.state?.from?.pathname || "/admin", { replace: true });
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-npst-navyDeep flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 mb-10 justify-center">
          <div className="w-11 h-11 rounded-sm bg-npst-gold text-npst-navyDeep flex items-center justify-center font-display font-bold text-lg">N</div>
          <div className="font-display text-white text-sm font-bold tracking-wide">NATIONAL PUBLIC SERVICE TRUST</div>
        </Link>
        <div className="bg-white rounded-lg p-8 shadow-2xl">
          <div className="label-eyebrow text-npst-gold mb-2">Administrative Portal</div>
          <h1 className="font-serif text-3xl text-npst-ink mb-6">Sign in</h1>
          {error && <div className="mb-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded px-3 py-2" data-testid="login-error">{error}</div>}
          <form onSubmit={submit} className="space-y-4">
            <div><label className="label-eyebrow text-npst-muted block mb-2">Email</label><Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12" /></div>
            <div><label className="label-eyebrow text-npst-muted block mb-2">Password</label><Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-12" /></div>
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full h-12 bg-npst-navy hover:bg-npst-navyDeep text-white uppercase tracking-[0.1em] text-sm">{loading ? "Signing in…" : "Sign in"}</Button>
          </form>
          <div className="mt-4 text-center"><Link to="/forgot-password" className="text-sm text-npst-muted hover:text-npst-navy">Forgot password?</Link></div>
        </div>
        <div className="text-center mt-6"><Link to="/" className="text-xs text-slate-400 hover:text-white">← Return to public site</Link></div>
      </div>
    </div>
  );
}
